module.exports = __webpack_public_path__ + "static/media/0327_IMG_L_ESPACE_DEGUSTATION_AVEC.5963109b.png";